import Vue from 'vue';
import { PER_PAGE } from '@/helpers/constants/app';
export default Vue.extend({
    data() {
        return {
            pageInfo: {
                startCursor: '',
                endCursor: '',
                hasNextPage: false,
                hasPreviousPage: false,
            },
            startCursor: null,
            totalCount: 0,
        };
    },
    computed: {
        perPage() {
            return PER_PAGE;
        },
    },
    methods: {
        fetchRecordsFrom(cursor) {
            this.startCursor = cursor;
        },
    },
});
